import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { IReduxAppState } from '../../reducers';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import IVenueSettings from '../../yoello-lib/modules/API/interfaces/IVenueSettings';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";
import { useTranslation } from 'react-i18next';

type AuthState = 'NONE' | 'FAIL' | 'SUCCESS';

const useSquareAuthChecker = () => {
    const { search } = useLocation();
    const { t } = useTranslation();
    const history = useHistory();

    const [ authState, setAuthState ] = useState<AuthState>();
    const [ isLoading, setIsLoading ] = useState(false);
    const { sendSnackbarMessage } = useSnackbarMessages()!;

    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);

    const { callAPI : callSquareAPI } = useAPIV2(APIExtensions.squareLocations, {
        onMountDisabled: true
    });

    const { callAPI: getUpdatedVenueSettings } = useAPIV2<IVenueSettings>(APIExtensions.venueSettings, {
        onMountDisabled: true,
        yoelloAPIParams: { 
            venue_id: selectedVenueId, 
            include_disabled: true, 
            include_hidden: true 
        },
        selectorKeyParams: { 
            venue_id: selectedVenueId 
        }

    });
    
    useEffect(() => {
        const code = new URLSearchParams(search).get("code");
        const redirectError = new URLSearchParams(search).get("error");
        const stateToken = new URLSearchParams(search).get("state");
        const storageToken = localStorage.getItem('square-csrf');

        if(code){
            if(redirectError || stateToken !== storageToken){
                setAuthState('FAIL');
            } else {
                setAuthState('SUCCESS');
            }
        } else {
            setAuthState('NONE');
        }
        //eslint-disable-next-line
    }, [])
    useEffect(() => {
        const code = new URLSearchParams(search).get("code");
        if(authState === 'SUCCESS') {
            setIsLoading(true);
            callSquareAPI(HTTPMethods.GET, {params: {code}}).then((response: any) => {
                setIsLoading(false);
                sendSnackbarMessage(t("square.sync.reauthorise.success"), "success");
                getUpdatedVenueSettings(HTTPMethods.GET).catch((error: Error) => {
                    sendSnackbarMessage(t("square.sync.reauthorise.fail"), "error");
                    console.log(error);
                })
             }).catch((error: Error) => {
                sendSnackbarMessage(t("square.sync.reauthorise.fail"), "error");
                 setIsLoading(false);
                 console.log(error);
             }).finally(() => {
                history.replace({search: ""});
             });
        }
        
         //eslint-disable-next-line
    },[authState])

    return {
        isLoading
    }
}

export default useSquareAuthChecker;